import React, { useState, useEffect } from "react";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppProvider, useApp } from "@/context/AppContext";
import { MainLayout } from "@/components/layout/MainLayout";
import { LinkVerification } from "@/components/verification/LinkVerification";
import { ArticleVerification } from "@/components/verification/ArticleVerification";
import { EmailVerification } from "@/components/verification/EmailVerification";
import { ArticleComparison } from "@/components/verification/ArticleComparison";
import { PhishingLab } from "@/components/verification/PhishingLab";
import { Dashboard } from "@/components/dashboard/Dashboard";
import { History } from "@/components/history/History";
import { AuthPage } from "@/components/auth/AuthPage";
import { AccountPage } from "@/components/account/AccountPage";
import { Toaster } from "@/components/ui/sonner";

const AppContent = () => {
  const { activeView, setActiveView } = useApp();
  const { loading } = useAuth();
  const [showAuth, setShowAuth] = useState(false);
  const [sharedUrl, setSharedUrl] = useState(null);

  // Handle ?url= query parameter for mobile share sheet / URL sharing
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const urlParam = params.get('url');
    if (urlParam) {
      setSharedUrl(urlParam);
      setActiveView('link');
      // Clean the URL without reloading
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, [setActiveView]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-8 h-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (showAuth) {
    return <AuthPage onClose={() => setShowAuth(false)} />;
  }

  const renderView = () => {
    switch (activeView) {
      case 'link':
        return <LinkVerification sharedUrl={sharedUrl} onSharedUrlConsumed={() => setSharedUrl(null)} />;
      case 'article':
        return <ArticleVerification />;
      case 'email':
        return <EmailVerification />;
      case 'compare':
        return <ArticleComparison />;
      case 'phishing-lab':
        return <PhishingLab />;
      case 'dashboard':
        return <Dashboard />;
      case 'history':
        return <History />;
      case 'account':
        return <AccountPage />;
      default:
        return <LinkVerification sharedUrl={sharedUrl} onSharedUrlConsumed={() => setSharedUrl(null)} />;
    }
  };

  return (
    <MainLayout onShowAuth={() => setShowAuth(true)}>
      {renderView()}
    </MainLayout>
  );
};

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <AppContent />
        <Toaster position="bottom-right" />
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
